<template>
  <v-card fill-height>
    <DialogKonfigurationRows ref="DialogKonfigurationRows" :structureData="tableData" @close="reloadConfig" @currentConfigName="updateCurrentConfigName"></DialogKonfigurationRows>
    <v-layout row justify-end>
      <v-flex md4>
        <v-layout row justify-end>
          <v-flex>
            <v-layout row justify-end>
              <SelectConfigurationList ref="cList" v-if="showSelect" @change="reload"></SelectConfigurationList>
              <v-icon @click="reload" color="#004884" class="handpointer">refresh</v-icon>
            </v-layout>
          </v-flex>
          <v-flex>
            <v-btn @click="openDialog" class="text-none" color="#004884" small outline>{{'BTN_KONFIGURATION'|translate}}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex md12>
        <StrukturBilanzTable configSuffix="KZ" :sortDisabled="true" :heightSub="tableHeightSub" ref="tabKennzahlen" tableName="total" :widthSub="40" edoClassName="kz"></StrukturBilanzTable>
      </v-flex>
    </v-layout>
  </v-card>
</template>
<script>
  import Vue from 'vue'
  import StrukturBilanzTable from './StrukturBilanzTable'
  import BtnDownloadExcel from './../../widgets/BtnDownloadExcel'
  import DialogKonfigurationRows from './../dialogs/DialogKonfigurationRows'
  import SelectConfigurationList from './../../widgets/SelectConfigurationList'

  export default {
    name: 'TabKennzahlen',
    components: {StrukturBilanzTable, BtnDownloadExcel, DialogKonfigurationRows, SelectConfigurationList},
    props: ['balance', 'isPeergroup', 'balanceArray'],
    methods: {
      open: function () {
        Vue.prototype.$eventHub.$emit('OnGetExcelConfig', this.configExcel)
        this.reload()
      },
      updateCurrentConfigName (cName) {
        if (cName) {
          if (this.$refs.cList) {
            this.$refs.cList.updateConfigNameFromDialog(cName)
          }
        }
      },
      reloadConfig() {
        let cmp = this
        console.log('reloadConfig')
        if (this.$refs.cList) {
          this.$refs.cList.reload({
            rk: cmp.tableData.commonRkNr,
            guvNr: cmp.tableData.commonGuvNr
          })
        }
      },
      openDialog() {
        this.$refs.DialogKonfigurationRows.show(this.data)
      },
      close: function () {
        this.$refs['tabKennzahlen'].close()
      },
      onGetData: function (data) {
        Vue.prototype.$api.debug('Kennzahlen', data)
        this.tableData = data
        if (this.$refs.cList) {
          this.$refs.cList.reload({
            rk: data.commonRkNr,
            guvNr: data.commonGuvNr
          })
        }
        Vue.prototype.$api.hideIdle()
        this.showSelect = true
        if (this.$refs['tabKennzahlen'] && this.$refs['tabKennzahlen'].open) {
          this.$refs['tabKennzahlen'].open(data)
        }
      },
      reload: function (configName) {
        this.configName = Vue.prototype.storage.getConfigName()

        Vue.prototype.$api.debug('reload', configName, this.balance, this.$refs.myTab, this.balanceArray, this.isPeergroup)
        Vue.prototype.$api.showIdle()
        if (this.isPeergroup) {
          Vue.prototype.$api.createKennzahlenDataWithBalanceArray(this.balanceArray, this.configName, this.onGetData)
        } else {
          Vue.prototype.$api.createKennzahlenDataWithBalance(this.balance, this.configName, this.onGetData)
        }
      }
    },
    data() {
      return {
        showSelect: true,
        configExcel: {
          excelSheetStammdaten: 0,
          excelSheetStrukturbilanz: 0,
          excelSheetRohbilanz: 0,
          excelSheetKennzahlen: 1,
          excelSheetBilanzrating: 0,
          excelSheetKDF: 0,
          btnName: Vue.i18n.translate('DOWNLOAD_NAME_KZ'),
          configName: '',
          type: 'EXCEL-STRUCT'
        },
        configName: '',
        tableData: null,
        tableHeightSub: 170
      }
    },
    mounted() {
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/module/akte/TabKennzahlen.vue